import { Model } from "./model";

export class Shop extends Model {
    id: number;
    country_id: number;
    country_name?: string;
    region_id: number;
    retailer_id: number;
    name: string;
    number?: string;
    address?: string;
    zipcode?: string;
    city?: string;
    info?: string;
}


// WEBPACK FOOTER //
// ./src/models/shop.model.ts